import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { UserContext } from "../../Context";

import ProfileFormReferenceAdd from "../profileFormReferenceAdd/ProfileFormReferenceAdd";

import "./profileFormReferences.css";
import ProfileFormReferenceCard from "../profileFormReferenceCard/ProfileFormReferenceCard";

// const required = 2;
export default class ProfileFormReferences extends Component {
  render() {
    return (
      <UserContext.Consumer>
        {userContext => (
          <div className="profile-form-references">
            <Helmet>
              <title>{`Profile | References`}</title>
            </Helmet>
            {userContext.my &&
            userContext.my.references &&
            !!Object.keys(userContext.my.references)[0] ? (
              Object.keys(userContext.my.references)
                .filter((referenceId, i) => i === 0)
                .map(referenceId => userContext.my.references[referenceId])
                .map((reference, i) => (
                  <ProfileFormReferenceCard
                    userContext={userContext}
                    index={1}
                    reference={reference}
                  />
                ))
            ) : (
              <ProfileFormReferenceAdd
                key={`add-reference-card-${1}`}
                title={`Add Reference #${1}`}
                userContext={userContext}
              />
            )}
          </div>
        )}
      </UserContext.Consumer>
    );
  }
}
// {
//   {
//   userContext.my &&
//     userContext.my.references &&
//     !!Object.keys(userContext.my.references)[1] ? (
//       Object.keys(userContext.my.references)
//         .filter((referenceId, i) => i === 1)
//         .map(referenceId => userContext.my.references[referenceId])
//         .map((reference, i) => (
//           <ProfileFormReferenceCard
//             userContext={userContext}
//             index={2}
//             reference={reference}
//             key={`reference-card-${2}`}
//           />
//         ))
//     ) : (
//       <ProfileFormReferenceAdd
//         key={`add-reference-card-${2}`}
//         title={`Add Reference #${2}`}
//         userContext={userContext}
//       />
//     )
//   }
// }



// WEBPACK FOOTER //
// ./src/components/profileFormReferences/ProfileFormReferences.js